import { AppDispatchNext } from 'actions/actions.typesNext'
import { goBackToBaseUrlAction } from 'actions/route/routeAction'
import { pushShortCutNotificationAction } from 'actions/uninotice/noticeShortCutAction'
import { NotificationType } from 'components/presentational/Notifications/NotificationType'
import {
  PaymentType,
  StorefrontService,
} from 'components/storefront/StoreFront.constants'

const findNotificationType = (
  storeFrontType: StorefrontService,
  paymentType: PaymentType | undefined,
  ok: boolean
): NotificationType => {
  if (ok) {
    switch (storeFrontType) {
      case StorefrontService.featuredPhotos:
        return NotificationType.featuredPhotos
      case StorefrontService.makeTop:
        return NotificationType.makeTop
      case StorefrontService.photoLine:
        return NotificationType.photoLine
    }
    switch (paymentType) {
      case PaymentType.BankCards:
      case PaymentType.YooKassa:
      case PaymentType.YandexMoney:
        return NotificationType.orderBankCardSuccess
      case PaymentType.Mobile:
        return NotificationType.orderMobileSuccess
      case PaymentType.Coins:
        return NotificationType.orderCoinsSuccess
    }
    console.error(`Unexpected payment type "${paymentType}"`)
    return NotificationType.orderBankCardSuccess
  }
  return NotificationType.genericError
}
/**
 * Финальный экшен показа результата оплаты
 * @param storeFrontType тип услуги
 * @param orderId
 * @param ok успешно или нет
 * @param paymentType тип платежа
 * @param showShortCutNotification
 */
export const performResultAction =
  (
    storeFrontType: StorefrontService,
    orderId: string,
    ok: boolean,
    paymentType?: PaymentType,
    showShortCutNotification: boolean = true
  ) =>
  (dispatch: AppDispatchNext) => {
    if (ok === true && paymentType === PaymentType.Mobile) {
      dispatch(goBackToBaseUrlAction())
    } else {
      window.setTimeout(() => {
        const pathname = window.location.pathname
        window.history.back()
        /**
         * Код ниже нужен исключительно для фикса тестовой оплаты https://youtrack.mamba.ru/issue/M-11161
         * Причина не до конца ясна, но видимо тестовый iframe делает push ссылки типа:
         * https://www.mamba.ru/chats/1786072683/contact/app/storefront/gifts/form/order/33e6dd80-ef6a-11ef-b54e-fe0741315db4/type/BankCards
         * дважды.
         * Поэтому window.history.back() не возвращает нас куда нужно, а оставляет на этом же урле.
         * Поэтому нам нужен еще один window.history.back()
         */
        if (process.env.SENTRY_ENV === 'staging') {
          window.setTimeout(() => {
            if (pathname === window.location.pathname) {
              window.history.back()
            }
          }, 0)
        }
      }, 0)
    }

    if (showShortCutNotification) {
      return dispatch(
        pushShortCutNotificationAction(
          findNotificationType(storeFrontType, paymentType, ok)
        )
      )
    }
  }
